import "intersection-observer"

import type { ButtonHTMLAttributes } from "react"
import React from "react"
import { Bookmark } from "react-feather"
import clsx from "clsx"

type BookmarkButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export const BookmarkButton: React.FC<BookmarkButtonProps> = ({
  children,
  ...props
}) => {
  return (
    <button
      className={clsx(
        "flex items-center justify-center",
        "rounded p-2",
        "bg-primary-500 text-white hover:bg-primary-700",
        "dark:bg-secondary-500 dark:text-primary-900 dark:hover:bg-secondary-200",
      )}
      type="button"
      {...props}
    >
      <Bookmark size={20} />
      {children}
    </button>
  )
}
